import React, { useEffect, useState } from 'react';
import { Table, Breadcrumb } from 'antd';
import { HomeOutlined } from '@ant-design/icons';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../../authConfig';
import { Link } from 'react-router-dom';
import useUserProfile from '../../useUserProfile';
import { getuid } from 'process';
import { useTranslation } from 'react-i18next';
import { fetchWithRetry } from '../utils/fetchWithRetry';

interface BalancePointsData{
  points:number;
  real_value:number;
  country_id: number;
  currency_name:string;
  currency_hex:boolean;
  pointsPerUnitCurrency:number;
}

const ShowUserPointsComponent: React.FC = () => {
  const [UserDetails, setUserDetails] = useState<{ id:string , displayName: string, email: string }[]>([]);
  const { instance, accounts } = useMsal();
  const { requestProfileData } = useUserProfile();
  const [pointsData, setPointsData] = useState<any[]>([]);
  const [balancePoints, setBalancePoints] = useState<BalancePointsData>();
  const { t } = useTranslation();

    useEffect(() => {
    const fetchProfileData = async () => {
        try {
        await requestProfileData();
        const userMail = localStorage.getItem("UserMail");
        const userName = localStorage.getItem("UserName");
        const userId = localStorage.getItem("UserId");
        setUserDetails([{ id: userId || '', displayName: userName || 'Default Nominator', email: userMail || '' }]);
        } catch (error) {
        console.error('Error fetching profile data:', error);
        }
    };

    fetchProfileData();
    }, [requestProfileData]);


  const callMsGraph = async (token: any) => {
    const headers = new Headers();
    headers.append("Authorization", `Bearer ${token}`);
    const response = await fetchWithRetry(`https://graph.microsoft.com/v1.0/me?`, {
      method: "GET",
      headers,
    }).then((response) => response.json());
    return response;
  };
  const fetchToken = async () => {
    const res = await instance.acquireTokenSilent({
      ...loginRequest,
      account: accounts[0]
    });
    return res.idToken;
  };

  useEffect(() => {
    fetchToken();
    getUserPoints();
  }, []);

  //Get Balance Points of the logged-in user
  const getUserPoints = async () => {
    try {
      const token = await fetchToken();
      const userId = localStorage.getItem("UserId");
        if (!userId) {
          console.error('UserId is undefined.');
          return;
        }
        // Fetch points data from the API
        const response = await fetchWithRetry(
          `${process.env.REACT_APP_API_URL}/api/VantageCircle/GetUserBalancePoints/${userId}`,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (!response.ok) {
          throw new Error(`Error: ${response.status} - ${response.statusText}`);
        }
        const responseData = await response.json();
        setBalancePoints(responseData);
    }
    catch (error) {
      console.error('Error fetching balance points data:', error);
    }
  };

  useEffect(() => {
    const fetchPointsData = async () => {
      try {
        if (UserDetails.length === 0) {
          return;
        }  
        const token = await fetchToken();
        const userId = UserDetails[0].id;  
        if (!userId) {
          console.error('UserId is undefined.');
          return;
        }  
        const response = await fetchWithRetry(
          `${process.env.REACT_APP_API_URL}/api/ManagerBudget/GetUserPoints?userId=${userId}`,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (!response.ok) {
          throw new Error(`Error: ${response.status} - ${response.statusText}`);
        }

        const data = await response.json();
        const transformedData = data.map((item: any) => ({
          ...item,
          createdDate: new Date(item.createdDate).toLocaleDateString(),
        }));
        setPointsData(transformedData);
      } catch (error) {
        console.error('Error fetching points data:', error);
      }
    };  

    if (UserDetails.length > 0) {
      fetchPointsData();
    }
  }, [UserDetails]); 

const columns = [
  {
    title: t('description'),
    dataIndex: 'description',
    key: 'Description',
    width: '16.6%',
    align: 'center' as 'center',
    render: (text: string) => text, // Use the actual description value
  },
  {
    title: t('points_received'),
    dataIndex: 'pointsRecived',
    key: 'PointsRecived',
    width: '16.6%',
    align: 'center' as 'center',
  },
  {
    title: t('received_date'),
    dataIndex: 'createdDate',
    key: 'CreatedDate',
    width: '16.6%',
    align: 'center' as 'center',
    render: (text: string) => new Date(text).toLocaleDateString(),
  },
];

return (
  <div style={{ padding: '20px', backgroundColor: '#f5f5f5', borderRadius: '8px' }}>
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: '#ffffff',
        borderRadius: '8px',
        padding: '15px 20px',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
      }}
    >
      <Breadcrumb
        style={{
          backgroundColor: 'transparent',
          padding: 0,
          margin: 0,
        }}
      >
        <Breadcrumb.Item>
          <Link to="/home" >
            <HomeOutlined style={{ marginRight: '5px', color: '#1890ff' }} />
            {t('home')}
          </Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>{t('earned_points')}</Breadcrumb.Item>
      </Breadcrumb>

      <div>
        <b>{t('balance')}: {balancePoints?.points}</b>
      </div>

    </div>
    <div
      style={{
        marginTop: '20px',
        backgroundColor: '#ffffff',
        borderRadius: '8px',
        padding: '20px',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
      }}
    >
      <Table
        columns={columns.map((col) => ({
          ...col,
          align: 'center',
        }))}
        dataSource={pointsData}
        rowKey="EmployeeEmail"
        bordered
        locale={{ emptyText: 'No Points' }} 
        pagination={{ pageSize: 10 }}
        style={{
          borderRadius: '8px',
          overflow: 'hidden',
        }}
      />
    </div>
  </div>
);
};

export default ShowUserPointsComponent;